import axios from 'axios'

const agentRequest = axios.create({
	baseURL: '/agent-api/',
	timeout: 60000,
})

export function chatWithAgent(data) {
	return agentRequest({
		url: 'chat',
		method: 'POST',
		data
	})
}
